import { generateGuid } from "./kendo_common";
import { useEffect, useRef } from "react";

export const KendoDatePicker = ({
  name,
  value,
  required,
  onChange,
  disablePast = false,
}) => {
  const guid = generateGuid();
  const datepickerRef = useRef(null);

  useEffect(() => {
    const today = new Date();
    // Initialize Kendo DatePicker
    if (disablePast) {
      $(datepickerRef.current).kendoDatePicker({
        value: value !== "" ? new Date(value) : today,
        min: new Date(),
        componentType: "modern",
        change: function (e) {
          const value = this.value();
          onChange(value);
        },
      });
    } else {
      $(datepickerRef.current).kendoDatePicker({
        value: value !== "" ? new Date(value) : today,
        componentType: "modern",
        change: function (e) {
          const value = this.value();
          onChange(value);
        },
      });
    }
  }, []);

  useEffect(() => {
    if (datepickerRef.current) {
      const kendoDatePicker = $(datepickerRef.current).data("kendoDatePicker");
      if (kendoDatePicker) {
        kendoDatePicker.value(value !== "" ? new Date(value) : new Date());
      }
    }
  }, [value]);
  return (
    <>
      <input
        name={name}
        id={`datepicker`}
        data-required={required || false}
        ref={datepickerRef}
      />
    </>
  );
};
